import { mapState } from 'vuex';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinKeyValueEditor',
  props: {
    twinObject: {
      type: Object,
      required: true
    },
    hasTwinEditPermission: {
      type: Boolean,
      required: true
    },
    deviceTemplate: {
      type: Object,
      required: false,
      default: null
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    },
    oneColLayout: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      mandatoryProperties: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    twinCanBeEdited() {
      return this.hasTwinEditPermission && !this.dtwinIsDisabled && !this.cloading;
    },
    dtwinIsDisabled() {
      return get(this.twinObject, 'properties.disabled');
    },
    isCreatedByTemplate() {
      return !!this.deviceTemplate;
    },
    cloading() {
      return this.$store.state.app.loading;
    },
    requiredRule() {
      return v => !!v || this.$i18n_t('Common.fieldRequired');
    }
  },
  watch: {
    twinObject() {
      this.initialMetaDataSetup();
    }
  },
  created() {
    this.initialMetaDataSetup();
  },
  methods: {
    get,
    initialMetaDataSetup() {
      if (!this.twinObject.data) {
        this.twinObject.data = {};
      }
      if (!this.twinObject.data.keyValue) {
        this.twinObject.data.keyValue = {};
      }
      if (this.twinObject.data.keyValue[''] === '') {
        delete this.twinObject.data.keyValue[''];
      }
      if (this.isCreatedByTemplate) {
        const templateCustomProperties = this.deviceTemplate.deviceMeta.customProperties;
        Object.keys(templateCustomProperties).forEach(cpKey => {
          if (templateCustomProperties[cpKey].requiredValue) {
            this.mandatoryProperties.push(cpKey);
          }
        });
      }
    },
    isTemplatePropertyMandatory(key) {
      return this.mandatoryProperties.includes(key);
    },
    keyValueKeyChanged(prior, newKey) {
      const baseKey = newKey;
      let uniqueKey = newKey;
      let i = 0;
      while (this.twinObject.data.keyValue[uniqueKey] !== undefined) {
        i++;
        uniqueKey = `${baseKey}${i}`;
      }
      this.twinObject.data.keyValue[uniqueKey] = this.twinObject.data.keyValue[prior];
      delete this.twinObject.data.keyValue[prior];
      this.twinObject.data = cloneDeep(this.twinObject.data);
    },
    addKeyValuePair() {
      if (this.twinObject.data.keyValue[''] === undefined) {
        this.twinObject.data.keyValue[''] = '';
      } else {
        const baseKey = 'Key';
        let uniqueKey = baseKey;
        let i = 0;
        while (this.twinObject.data.keyValue[uniqueKey] !== undefined) {
          i++;
          uniqueKey = `${baseKey}${i}`;
        }
        this.twinObject.data.keyValue[uniqueKey] = '';
      }
      this.twinObject.data = cloneDeep(this.twinObject.data);
    },
    removeKeyValuePair(key) {
      delete this.twinObject.data.keyValue[key];
      this.twinObject.data = cloneDeep(this.twinObject.data);
    }
  }
};